import { ColumnID } from './types';
import { CommunicationModalState, ModalMode } from '../index';
import { css } from '@emotion/react';
import StatusCell from './status-cell';
import SubjectCell from './subject-cell';
import OptionsCell from './options-cell';
import AudienceCell from '../../audience-cell';
import MessageTypeCell from './message-type-cell';
import { config } from '@config/pendo.config.json';
import { shadedWhite } from 'athena/styles/colors';
import { communicationCustomStyles } from './styles';
import { RowProps } from 'shared/components/nv-table';
import NvTableCells from 'shared/components/nv-table/nv-table-cells';
import ClickableContainer from 'components/clickable-container';
import { gray7, highTide } from 'styles/global_defaults/colors';
import { MentorshipProgramCustomCommunication } from 'redux/schemas/models/mentorship-program-custom-communications';
import { Dispatch, SetStateAction } from 'react';

const styles = (isEnabled: boolean) => css`
  ${communicationCustomStyles};
  border-bottom: 1px solid ${shadedWhite};

  &:hover,
  &:focus-within {
    background-color: ${gray7};

    .options-target {
      opacity: 1;
    }
    ${isEnabled &&
    `
    .subject {
      color: ${highTide};
    }
    `}
  }

  &:last-of-type {
    border-bottom: 0;
  }
`;

const cells = {
  [ColumnID.MESSAGE_TYPE]: MessageTypeCell,
  [ColumnID.SUBJECT]: SubjectCell,
  [ColumnID.TO]: AudienceCell,
  [ColumnID.STATUS]: StatusCell,
  [ColumnID.OPTIONS]: OptionsCell,
};

const CustomCommunicationRow = ({
  row,
  className,
  getCellStyle,
  setModalState,
}: RowProps<MentorshipProgramCustomCommunication> & {
  setModalState: Dispatch<SetStateAction<CommunicationModalState>>;
}) => {
  const { original: mentorshipProgramCustomCommunication } = row || {};
  const { id, enabled } = mentorshipProgramCustomCommunication || {};

  const dataQATag =
    config.pendo.athena.mentorshipProgram.communications.communicationRow;

  return (
    <ClickableContainer
      css={styles(enabled)}
      className={className}
      data-qa={dataQATag}
      data-qa-id={`${dataQATag}_${id}`}
      onClick={() =>
        setModalState({ mode: ModalMode.VIEW, communicationId: id })
      }
    >
      <NvTableCells row={row} getCellStyle={getCellStyle} cellMap={cells} />
    </ClickableContainer>
  );
};

export default CustomCommunicationRow;
